import { format  } from "date-fns";
import { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { Configuration } from './Configuration';

var configuration : Configuration;

export function setConfiguration(jsonConfiguration : Configuration) {
  configuration = jsonConfiguration;
}

export function getConfiguration() {
  return configuration;
}

export function getDefaultUsername() {
  if (sessionStorage.getItem('username')) {
    return sessionStorage.getItem('username');
  }
  return '';
}

export function logTime(date: Date) {
  console.log(date);
  console.log("System Local Time:      ", date.toString());
  console.log("UTC (ISO):              ", date.toISOString());
  console.log("UTC (string):           ", date.toUTCString());
  console.log("Local .toLocaleString():", date.toLocaleString());
  console.log("\n\n");
}

export function getTimeZoneLabel() {
  if (configuration && configuration.settings) {
    if (configuration.settings.useSystemAdminTimeSetting) {
      if ( sessionStorage.getItem('isLocalAirportTime')?.toUpperCase() !== 'TRUE' ) {
        return 'UTC';
      }
      else if (sessionStorage.getItem('timezoneLabel') != null) {
        return sessionStorage.getItem('timezoneLabel');
      }
    }
    
    if (configuration.settings.timeZoneLabel) {
      return configuration.settings.timeZoneLabel;
    }
  }
  return '';
}

export function useTimezoneSettings() {
  if (configuration && configuration.settings && configuration.settings.useSystemAdminTimeSetting && sessionStorage.getItem('isLocalAirportTime') != null) {
    return true;
  }
  return false;
}


export function getConfiguredTimeZone(){
  if (configuration.settings.useSystemAdminTimeSetting && sessionStorage.getItem('timezone') != null) {
    return sessionStorage.getItem('timezone');
  }
  if (configuration.settings && configuration.settings.timeZone) {
    return configuration.settings.timeZone;
  }
  return '';
}

export function getDefaultIdentityProvider(){
  if (sessionStorage.getItem('identityProvider')) {
    return sessionStorage.getItem('identityProvider');
  }
  return '';
}

export function prepareForLogout() {
  sessionStorage.setItem('expiredSession', 'true');
}

export function performLogout() {
  var sessionVal = '';
  if (sessionStorage.getItem('sessionId')) {
      if (sessionStorage && sessionStorage.getItem('sessionId')) {
          const value = sessionStorage.getItem('sessionId');
          if (value != null) {
              sessionVal = value;
          }
      }
  }
  const request = {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET',
          'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Authorization',
          'X-Saab-SessionID': sessionVal
      }
  };
  fetch('/externalApi/user/authentication/logout', request ).then(function (response) {
      return response.json();
  }).then(function () {
      removeSessionStorageAndReload();
  }).catch(
      e => {
        console.warn(e);
        removeSessionStorageAndReload();
      }
  );
}

function removeSessionStorageAndReload() {
  sessionStorage.removeItem('authenticated');
  sessionStorage.removeItem('sessionId');
  sessionStorage.removeItem('enableEdit');
  sessionStorage.removeItem('expiredSession');
  sessionStorage.removeItem('isLocalAirportTime');
  sessionStorage.removeItem('timezone');
  sessionStorage.removeItem('timezoneLabel');
  location.reload();
}

export function useThemeDetector() {
  const getCurrentTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [isDarkTheme, setIsDarkTheme] = useState(getCurrentTheme());  
  const mqListener = (e: { matches: boolean | ((prevState: boolean) => boolean); }) => {
      setIsDarkTheme(e.matches);
  };
  
  useEffect(() => {
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    darkThemeMq.addListener(mqListener);
    return () => darkThemeMq.removeListener(mqListener);
  }, []);
  return isDarkTheme;
}

export function getFormattedDate(date: string | number | Date | null) {
  if (date && date !== null) {
      return new Date(date).toUTCString().slice(-12, -7);
  } else {
      return '';
  }
}

export function getFormattedTime(date: string | number | Date | null) {
  if (!date || date == null) {
    return '';
  }

  if (configuration && configuration.settings) {
    if (configuration.settings.useSystemAdminTimeSetting) {
      if (sessionStorage.getItem('isLocalAirportTime')?.toUpperCase() !== 'TRUE') {
        return moment.utc(new Date(date), 'yyyy-MM-dd HH:mm').format('HH:mm');
      } 
      else if (sessionStorage.getItem('timezone') != null) {
        var userTimezone = sessionStorage.getItem('timezone') as string;
        return moment(new Date(date)).tz(userTimezone).format('HH:mm');
      }
    }
    
    if (configuration.settings.timeZone) {
      return moment(new Date(date)).tz(configuration.settings.timeZone).format('HH:mm');
    }
  }
  return format(new Date(date), 'HH:mm');
}

export function getDefaultTobt() {
  return getMinTobt();
}

export function getMinTobt() {
  var date = new Date();
  date.setMinutes(date.getMinutes() + 5);

  if (configuration && configuration.settings) {
    if (configuration.settings.useSystemAdminTimeSetting) {
      if (sessionStorage.getItem('isLocalAirportTime')?.toUpperCase() !== 'TRUE') {
        var utcDate = new Date(date.toLocaleString("en-US", {timeZone: "UTC"}));
        return utcDate;
      } else if (sessionStorage.getItem('timezone') != null) {
        var sessionTimezone = sessionStorage.getItem('timezone') as string;
        var localAirportDate =  new Date(date.toLocaleString("en-US", {timeZone: sessionTimezone}));
        return localAirportDate;
      }
    }

    if (configuration.settings.timeZone) {
      var localAirportDate =  new Date(date.toLocaleString("en-US", {timeZone: configuration.settings.timeZone}));
      return localAirportDate;
    }
  }
  return date;
}

export function getUtcFormat(date : Date) {
  var formattedDate = moment.tz(format(date, 'yyyy-MM-dd HH:mm'), Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (configuration && configuration.settings) {
    if (configuration.settings.useSystemAdminTimeSetting) {
      if (sessionStorage.getItem('isLocalAirportTime')?.toUpperCase() === 'FALSE') {
        var utcDate = moment.utc(format(date, 'yyyy-MM-dd HH:mm'));
        return utcDate.toISOString();
      } else if (sessionStorage.getItem('timezone') != null) {
        var userTimezone = sessionStorage.getItem('timezone') as string;
        var formattedDate = moment.tz(format(date, 'yyyy-MM-dd HH:mm'), userTimezone);
        return formattedDate.toISOString();
      }
    }

    if (configuration.settings.timeZone) {
      var formattedDate = moment.tz(format(date, 'yyyy-MM-dd HH:mm'), configuration.settings.timeZone);
      return formattedDate.toISOString();
    }
  }
  return formattedDate.toISOString();
}

export function isDateInThePast(inputDate: Date): boolean {
  // check if input date is before the current date for the configured timezone
  if (configuration && configuration.settings) {
    if (configuration.settings.useSystemAdminTimeSetting) {
      if (sessionStorage.getItem('isLocalAirportTime')?.toUpperCase() === 'FALSE') {
        return moment.utc(format(inputDate, 'yyyy-MM-dd HH:mm')).isBefore(moment.utc());
      } else if (sessionStorage.getItem('timezone') != null) {
        var userTimezone = sessionStorage.getItem('timezone') as string;
        return moment(inputDate).tz(userTimezone, true).isBefore(moment.tz(userTimezone));
      }
    }
    if (configuration.settings.timeZone) {
      return moment(inputDate).tz(configuration.settings.timeZone, true).isBefore(moment.tz(configuration.settings.timeZone));
    }
  }
  return inputDate < new Date();
};

export function getMaxTobt() {
  var date = new Date();
  date.setHours(date.getHours() + 10);
  if (configuration && configuration.settings) {
    if (configuration.settings.useSystemAdminTimeSetting) {
      if (sessionStorage.getItem('isLocalAirportTime')?.toUpperCase() !== 'TRUE') {
        var utcDate =  new Date(date.toLocaleString("en-US", {timeZone: "UTC"}));
        return utcDate;
      }
      else if (sessionStorage.getItem('timezone') != null) {
        var userTimezone = sessionStorage.getItem('timezone') as string;
        var timezoneDate = new Date(date.toLocaleString("en-US", {timeZone: userTimezone}));
        return timezoneDate;
      }
      else if (configuration.settings.timeZone) {
        var localAirportDate =  new Date(date.toLocaleString("en-US", {timeZone: configuration.settings.timeZone}));
        return localAirportDate;
      }
    }
  }

  return date;
}

export function isTobtValid (tobtToCheck: Date, minTobt: Date, maxTobt: Date): boolean {
  const tobtToCheckMinutes = tobtToCheck.getHours() * 60 + tobtToCheck.getMinutes();
  const minTobtMinutes = minTobt.getHours() * 60 + minTobt.getMinutes();
  const maxTobtMinutes = maxTobt.getHours() * 60 + maxTobt.getMinutes();

  // If the max tobt is earlier than the min tobt, the range crosses new day
  if (maxTobtMinutes < minTobtMinutes) {
    // Check if the new tobt is either later than the min tobt or earlier than the max tobt
    return tobtToCheckMinutes >= minTobtMinutes || tobtToCheckMinutes <= maxTobtMinutes;
  }

  // Check if the new tobt is between min and max
  return tobtToCheckMinutes >= minTobtMinutes && tobtToCheckMinutes <= maxTobtMinutes;
};

export function getUtcString (date: Date) {
  var localDate = new Date();
  localDate.setUTCHours(date.getHours());
  localDate.setMinutes(date.getMinutes());
  return localDate.toISOString();
}

export function getRollup(item: object, field: string) {
  if (item != null && configuration) {
    var lastRollupLabel = '';
    var value = '';
    var rollupObj = (configuration.flightList[field as keyof object] as any).rollup;
    for (var i =0; i < rollupObj.length; i ++) {
      lastRollupLabel = rollupObj[i].label;
      value = getFormattedTime((item[rollupObj[i].key as keyof Object] as any));
      if (value != '' && value != null) {
        if (rollupObj[i].paddingStart && rollupObj[i].paddingStart != '') {
          value = rollupObj[i].paddingStart + value;
        }
        if (rollupObj[i].paddingEnd && rollupObj[i].paddingEnd != '') {
          value = value + rollupObj[i].paddingEnd;
        }
        value =  lastRollupLabel + value;
        return value;
      }
    }
    if (value == '' || value == null) {
      return lastRollupLabel;
    }
  }
  return '';
}